import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    customerList: () => {
        return HTTP.get('/customer_all', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}